/* eslint-disable */
import { createContext } from 'react';

class Debug {
  static status;

  constructor(status = false) {
    this.setStatus(status);
  }

  setStatus(status) {
    this.status = status;
  }

  print(message, obj = {}) {
    if (this.status) console.log(message, obj);
  }
}

export const DebugContext = createContext(new Debug());
